import { observer } from 'mobx-react';
import React from 'react';
import { successNotification } from '../../../layout/components/Notifications/notifications';
import { VaultSecureIcon, VaultTooltipBarHowItWorksIcon, VaultTooltipConciergeIcon } from '../../assets/icons';
import {
    VaultTooltipButton,
    VaultTooltipButtonIcon,
    VaultTooltipButtonText,
    VaultTooltipConciergeContent,
    VaultTooltipHowItWorksContent,
    VaultTooltipsBarWrapper,
    VaultTooltipSecuredContent,
    VaultTooltipStepDetails,
    VaultTooltipStepIcon,
    VaultTooltipStepRow,
    VaultTooltipStepTitle
} from './VaultTooltipsBar.styles';
import { ModifiedTooltip } from '../../../../common/components/ModifiedTooltip/ModifiedTooltip';
import { VAULT_SECURE_TAG_TEXT } from '../Vault.const';

export const VaultTooltipsBar = observer(({ position = 'bottom' }) => {
    return (
        <VaultTooltipsBarWrapper position={position}>
            <ModifiedTooltip
                overlayInnerStyle={{ borderRadius: '12px' }}
                isLongText
                title={<VaultTooltipSecuredContent>
                    {VAULT_SECURE_TAG_TEXT}
                </VaultTooltipSecuredContent>} >
                <VaultTooltipButton>
                    <VaultTooltipButtonIcon>
                        <VaultSecureIcon />
                    </VaultTooltipButtonIcon>
                    <VaultTooltipButtonText>Secured</VaultTooltipButtonText>
                </VaultTooltipButton>
            </ModifiedTooltip>

            <ModifiedTooltip
                overlayInnerStyle={{ borderRadius: '12px' }}
                title={
                    <VaultTooltipConciergeContent>
                        Quickly and securely forward any
                        financial document you receive
                        via email to your Vault.
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px', color: '#72E1AC', cursor: 'pointer' }}
                            onClick={() => {
                                navigator.clipboard.writeText('secure-import@vyzer.co');
                                successNotification('Email copied');
                            }}>
                            secure-import@vyzer.co
                            <svg style={{ marginLeft: '8px' }} width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <rect x="3.5" y="5" width="7.5" height="9" rx="0.5" stroke="#72E1AC" />
                                <path d="M6 3H12C12.5523 3 13 3.44772 13 4V11" stroke="#72E1AC" strokeLinecap="round" />
                            </svg>
                        </div>
                    </VaultTooltipConciergeContent>
                }>
                <VaultTooltipButton>
                    <VaultTooltipButtonIcon>
                        <VaultTooltipConciergeIcon />
                    </VaultTooltipButtonIcon>
                    <VaultTooltipButtonText>Concierge</VaultTooltipButtonText>
                </VaultTooltipButton>
            </ModifiedTooltip>

            <ModifiedTooltip
                overlayInnerStyle={{ borderRadius: '12px' }}
                isLongText
                title={
                    <VaultTooltipHowItWorksContent>
                        <div style={{ padding: '16px 28px', fontWeight: '500' }}>3 steps to set up your portfolio:</div>
                        <div style={{ display: 'flex', flexDirection: 'column', padding: '0 20px 0 24px' }}>
                            <VaultTooltipStepRow>
                                <VaultTooltipStepIcon>
                                    <DocSvg />
                                </VaultTooltipStepIcon>
                                <VaultTooltipStepDetails>
                                    <VaultTooltipStepTitle>1. Import Files</VaultTooltipStepTitle>
                                    Import a file detailing your investment information, like a spreadsheet tracker or personal balance sheet
                                </VaultTooltipStepDetails>
                            </VaultTooltipStepRow>

                            <VaultTooltipStepRow>
                                <VaultTooltipStepIcon>
                                    <MagicBoxSvg />
                                </VaultTooltipStepIcon>
                                <VaultTooltipStepDetails>
                                    <VaultTooltipStepTitle>2. AI Convert Data</VaultTooltipStepTitle>
                                    Our AI processes your files and creates your basic portfolio structure instantly
                                </VaultTooltipStepDetails>
                            </VaultTooltipStepRow>

                            <VaultTooltipStepRow>
                                <VaultTooltipStepIcon>
                                    <SettingsSvg />
                                </VaultTooltipStepIcon>
                                <VaultTooltipStepDetails>
                                    <VaultTooltipStepTitle>3. Deep Analysis</VaultTooltipStepTitle>
                                    Our deep analysis process extracts all the financial data from your files, which can take up to 48 hours to complete
                                </VaultTooltipStepDetails>
                            </VaultTooltipStepRow>
                        </div>
                    </VaultTooltipHowItWorksContent>
                }>
                <VaultTooltipButton>
                    <VaultTooltipButtonIcon>
                        <VaultTooltipBarHowItWorksIcon />
                    </VaultTooltipButtonIcon>
                    <VaultTooltipButtonText>How it works?</VaultTooltipButtonText>
                </VaultTooltipButton>
            </ModifiedTooltip>

        </VaultTooltipsBarWrapper>
    );
});

const DocSvg = () => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.0445 12.9534L13.2075 13.2099C13.1602 12.9467 12.9442 12.5349 12.3367 12.5349C11.8845 12.5349 11.5875 12.8252 11.5875 13.1424C11.5875 13.4057 11.7562 13.6149 12.1072 13.6824L12.7755 13.8107C13.6462 13.9794 14.112 14.5464 14.112 15.2214C14.112 15.9572 13.4977 16.6997 12.384 16.6997C11.115 16.6997 10.5547 15.8829 10.4805 15.2012L11.3445 14.9717C11.385 15.4442 11.7157 15.8694 12.3907 15.8694C12.8902 15.8694 13.167 15.6197 13.167 15.2822C13.167 15.0054 12.9577 14.7894 12.5865 14.7152L11.9182 14.5802C11.1555 14.4249 10.6627 13.9322 10.6627 13.2099C10.6627 12.3594 11.4255 11.7114 12.33 11.7114C13.491 11.7114 13.9365 12.4134 14.0445 12.9534Z" fill="white" />
        <path d="M10.0918 16.5983L7.02734 16.5983L7.02734 11.8125L7.95884 11.8125L7.95884 15.7073L10.0918 15.7073L10.0918 16.5983Z" fill="white" />
        <path d="M6.35852 11.8125L4.79252 14.2088L6.36527 16.5983L5.23802 16.5983L4.20527 14.9445L3.16577 16.5983L2.07227 16.5983L3.64502 14.202L2.07902 11.8125L3.19952 11.8125L4.22552 13.4663L5.27177 11.8125L6.35852 11.8125Z" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M19.6563 8.99988L19.6563 21.1764C19.6563 21.6383 19.2818 22.0127 18.8199 22.0127L5.96133 22.0127C5.49944 22.0127 5.125 21.6383 5.125 21.1764L5.125 18.75L13.75 18.75C14.9926 18.75 16 17.7426 16 16.5L16 12C16 10.7574 14.9926 9.75 13.75 9.75L5.125 9.75L5.125 3.08653C5.125 2.62464 5.49944 2.2502 5.96133 2.2502L13.75 2.2502L13.75 7.49988C13.75 8.32831 14.4216 8.99988 15.25 8.99988L19.6563 8.99988ZM15.25 2.90679L15.25 7.49988L19.5147 7.49988C19.4901 7.46308 19.4624 7.42808 19.4318 7.39529L15.25 2.90679Z" fill="white" />
      </svg>
  
    )
  }
  
  const MagicBoxSvg = () => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11 10.56L3 8V17.12L11 19.68V10.56ZM13 10.56V19.68L21 17.12V8L13 10.56Z" fill="white" />
        <path d="M3 6.5L12 4.5L21 6.5L12 9L3 6.5Z" fill="white" />
      </svg>
    )
  }
  
  const SettingsSvg = () => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M13.7225 4.05483L13.4207 3H10.5793L10.2775 4.05485C9.95335 5.18765 8.66012 5.72497 7.62867 5.15539L6.6406 4.60977L4.63148 6.59216L5.1548 7.5148C5.74298 8.55178 5.20056 9.86546 4.05212 10.1854L3 10.4785V13.282L4.05212 13.5751C5.20056 13.895 5.74297 15.2087 5.15479 16.2457L4.63146 17.1683L6.64058 19.1507L7.62867 18.6051C8.66013 18.0355 9.95335 18.5728 10.2775 19.7056L10.5793 20.7605L13.4207 21L13.7516 19.7587C14.0587 18.607 15.3659 18.0499 16.4093 18.6261L17.3594 19.1507L19.3685 17.1683L18.8452 16.2457C18.257 15.2087 18.7994 13.895 19.9479 13.5751L21 13.282V10.4785L19.9479 10.1854C18.7994 9.86545 18.257 8.55179 18.8452 7.51481L19.3685 6.59214L17.3594 4.60975L16.3713 5.15537C15.3399 5.72495 14.0466 5.18764 13.7225 4.05483ZM11.9987 7.43301C9.47657 7.43301 7.43201 9.47758 7.43201 11.9997C7.43201 14.5218 9.47657 16.5663 11.9987 16.5663C14.5208 16.5663 16.5653 14.5218 16.5653 11.9997C16.5653 9.47758 14.5208 7.43301 11.9987 7.43301ZM9.23201 11.9997C9.23201 10.4717 10.4707 9.23301 11.9987 9.23301C13.5267 9.23301 14.7653 10.4717 14.7653 11.9997C14.7653 13.5277 13.5267 14.7663 11.9987 14.7663C10.4707 14.7663 9.23201 13.5277 9.23201 11.9997Z" fill="white" />
      </svg>
    )
  }